module.exports = __webpack_public_path__ + "static/digitallabin-099c3505675dab8d1754bd89521f9884.jpg";